import template from './loansSignUpResume.html';
import controller from './loansSignUpResume.controller';
import './loansSignUpResume.scss';

let loansSignUpResumeComponent = {
  restrict: 'E',
  bindings: {
    success: '<',
    error: '<',
    loan: '<',
    message: '<',
    loanResponseId: '<',
    simulation: '<',
    goToInitForm: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansSignUpResumeComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpResume/loansSignUpResume.component.js